const facebookSVG = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='36'
		height='36'
		viewBox='0 0 36 36'
		fill='none'
	>
		<g clipPath='url(#clip0_1420_4358)'>
			<path
				d='M33.75 18.0119C33.7473 15.0324 32.8994 12.1148 31.3049 9.5978C29.7105 7.08083 27.4347 5.06777 24.742 3.79234C22.0493 2.51692 19.05 2.03145 16.0924 2.39232C13.1348 2.75319 10.3403 3.94558 8.03323 5.83105C5.72617 7.71652 4.00125 10.2177 3.05875 13.0442C2.11626 15.8708 1.99484 18.9066 2.70861 21.7994C3.42237 24.6922 4.94204 27.3231 7.09115 29.3868C9.24027 31.4505 11.9307 32.8623 14.85 33.4582V22.7403H11.7V18.0153H14.85V14.0778C14.8521 12.6164 15.4335 11.2155 16.4669 10.1822C17.5002 9.14882 18.9011 8.56737 20.3625 8.56529H24.3V13.2903H21.15C20.7323 13.2903 20.3317 13.4562 20.0363 13.7516C19.7409 14.047 19.575 14.4476 19.575 14.8653V18.0153H24.3V22.7403H19.575V33.6944C23.4619 33.3038 27.0649 31.4826 29.6843 28.5845C32.3038 25.6865 33.7528 21.9184 33.75 18.0119Z'
				fill='var(--yellow1000)'
			/>
		</g>
		<defs>
			<clipPath id='clip0_1420_4358'>
				<rect
					width='36'
					height='36'
					fill='var(--white1000)'
				/>
			</clipPath>
		</defs>
	</svg>
);

const instagramSVG = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='36'
		height='36'
		viewBox='0 0 36 36'
		fill='none'
	>
		<g clipPath='url(#clip0_1420_4361)'>
			<g clipPath='url(#clip1_1420_4361)'>
				<path
					d='M18.4973 14.0491C17.4299 14.0289 16.3982 14.4334 15.6291 15.1737C14.8599 15.9139 14.4162 16.9294 14.3955 17.9967C14.4162 19.064 14.8599 20.0794 15.6291 20.8197C16.3982 21.56 17.4299 21.9645 18.4973 21.9443C19.5642 21.9639 20.5953 21.5591 21.364 20.8189C22.1327 20.0787 22.5761 19.0636 22.5968 17.9967C22.5761 16.9298 22.1327 15.9147 21.364 15.1745C20.5953 14.4343 19.5642 14.0295 18.4973 14.0491Z'
					fill='var(--yellow1000)'
				/>
				<path
					d='M26.0195 5H10.9738C9.38961 5 7.87033 5.62922 6.75007 6.74927C5.62981 7.86933 5.0003 9.38848 5 10.9726L5 25.025C5 26.6093 5.62938 28.1288 6.74967 29.2491C7.86997 30.3694 9.38941 30.9988 10.9738 30.9988H26.0195C26.8039 30.9988 27.5807 30.8442 28.3054 30.544C29.0301 30.2438 29.6886 29.8037 30.2432 29.249C30.7978 28.6943 31.2377 28.0357 31.5378 27.311C31.8379 26.5862 31.9923 25.8094 31.9921 25.025V10.9738C31.9921 9.38961 31.3629 7.87033 30.2429 6.75007C29.1228 5.62981 27.6036 5.0003 26.0195 5ZM18.5 24.7584C16.6734 24.7921 14.9082 24.0992 13.5923 22.8321C12.2764 21.5649 11.5174 19.827 11.4823 18.0005C11.5171 16.1738 12.276 14.4357 13.5919 13.1682C14.9079 11.9008 16.6733 11.2078 18.5 11.2415C20.3266 11.2078 22.0918 11.9006 23.4077 13.1678C24.7236 14.435 25.4826 16.1728 25.5178 17.9994C25.4829 19.8261 24.724 21.5642 23.4081 22.8317C22.0921 24.0991 20.3267 24.7921 18.5 24.7584ZM26.3244 12.281C25.8325 12.29 25.3572 12.1034 25.003 11.762C24.6488 11.4207 24.4447 10.9526 24.4355 10.4608C24.4561 9.97346 24.6642 9.51296 25.0163 9.17545C25.3683 8.83793 25.8372 8.6495 26.3249 8.6495C26.8127 8.6495 27.2815 8.83793 27.6336 9.17545C27.9857 9.51296 28.1938 9.97346 28.2144 10.4608C28.2049 10.9527 28.0005 11.4208 27.6461 11.7621C27.2917 12.1034 26.8163 12.29 26.3244 12.281Z'
					fill='var(--yellow1000)'
				/>
			</g>
		</g>
		<defs>
			<clipPath id='clip0_1420_4361'>
				<rect
					width='36'
					height='36'
					fill='var(--white1000)'
				/>
			</clipPath>
			<clipPath id='clip1_1420_4361'>
				<rect
					width='26.9932'
					height='25.9954'
					fill='var(--white1000)'
					transform='translate(5 5)'
				/>
			</clipPath>
		</defs>
	</svg>
);

const linkedinSVG = (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="36" 
		height="36" 
		viewBox="0 0 36 36" 
		fill="none"
	>
		<g clipPath="url(#clip0_1028_4799)">
			<path 
				d="M11.0982 31.5H5.0937V13.9005H11.0847V31.5H11.0982ZM8.1027 11.5504C6.11919 11.5504 4.5 9.97922 4.5 8.02518C4.5 6.07115 6.1057 4.5 8.1027 4.5C10.0997 4.5 11.7054 6.07115 11.7054 8.02518C11.7054 9.97922 10.0997 11.5504 8.1027 11.5504ZM31.4865 31.5H25.4955V22.1919C25.4955 20.5944 24.2271 19.2345 22.6079 19.1817C20.9078 19.1289 19.5045 20.4623 19.5045 22.1127V31.5H13.5135V13.9005H19.5045V15.8281C20.7054 14.3098 22.6889 13.3196 24.9018 13.3196C28.2076 13.3196 31.5 15.6697 31.5 20.3567V31.5H31.4865Z" 
				fill="var(--yellow1000)"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1028_4799">
				<rect 
					width="36" 
					height="36" 
					fill="var(--white1000)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export { facebookSVG, instagramSVG, linkedinSVG };
